import { Modal as MuiModal, Box, Typography, Button, CircularProgress } from '@mui/material';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

interface ModalDeleteProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
    userName: string;
}

export function ModalDelete({ open, onClose, onConfirm, loading, userName }: ModalDeleteProps) {
    return (
        <MuiModal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-delete-title"
            aria-describedby="modal-delete-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 4,
                    minWidth: 420,
                    maxWidth: '100vw',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        background: '#FDEAEA',
                        borderRadius: '50%',
                        width: 56,
                        height: 56,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                    }}
                >
                    <PersonOffOutlinedIcon sx={{ color: '#D92D20', fontSize: 32 }} />
                </Box>
                <Typography
                    id="modal-delete-title"
                    sx={{
                        fontWeight: 600,
                        fontSize: 18,
                        color: '#101828',
                        mb: 1,
                        textAlign: 'center',
                    }}
                >
                    Confirmar exclusão
                </Typography>
                <Typography
                    id="modal-delete-description"
                    sx={{
                        color: '#344054',
                        fontSize: 15,
                        textAlign: 'center',
                        mb: 3,
                    }}
                >
                    Tem certeza que deseja excluir o usuário <b>{userName}</b>?<br />
                    Esta ação não poderá ser desfeita.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, width: '100%', mt: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        disabled={loading}
                        sx={{
                            flex: 1,
                            bgcolor: '#F9FAFB',
                            color: '#344054',
                            borderColor: '#F2F4F7',
                            borderRadius: 2,
                            fontWeight: 600,
                            fontSize: 15,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: '#F2F4F7', borderColor: '#F2F4F7' },
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={onConfirm}
                        disabled={loading}
                        startIcon={<DeleteIcon />}
                        sx={{
                            flex: 1,
                            bgcolor: '#D92D20',
                            color: '#fff',
                            borderRadius: 2,
                            fontWeight: 600,
                            fontSize: 15,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: '#B42318' },
                        }}
                    >
                        {loading ? <CircularProgress size={22} color="inherit" /> : 'Deletar usuário'}
                    </Button>
                </Box>
            </Box>
        </MuiModal>
    );
}
